import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import {
  saveBoxTemplate,
} from '../../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';

const BoxTemplateModal = ({ isOpen, onClose, toUpdate }) => {
  const schema = yup
    .object({
      templateName: yup.string().required('Template name is required'),
    })
    .required();

  const dispatch = useDispatch();
  const toast = useToast();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveTemplate = async data => {
    const res = await dispatch(
      saveBoxTemplate({
        name: data.templateName,
        isUpdate: toUpdate,
      })
    );

    if (res.type === 'boxTemplate/saveBoxTemplate/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      reset();
      onClose();
      toast({
        description: toUpdate.state
          ? 'Template updated successfully'
          : 'Template added successfully',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => {
        reset();
        onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSaveTemplate)}>
          <ModalHeader>{toUpdate.state ? 'Edit' : 'Add'} template</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl id="templateName" isInvalid={errors.templateName}>
              <FormLabel>Template Name</FormLabel>
              <Input
                defaultValue={toUpdate.state ? toUpdate.template.name : ''}
                id="templateName"
                {...register('templateName')}
              />
              <FormErrorMessage>
                {errors.templateName && errors.templateName.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button onClick={onClose} variant="outline" disabled={isSubmitting}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default BoxTemplateModal;
